import { render, staticRenderFns } from "./GoalConfigModal.vue?vue&type=template&id=17a487cd&"
import script from "./GoalConfigModal.vue?vue&type=script&lang=js&"
export * from "./GoalConfigModal.vue?vue&type=script&lang=js&"
import style0 from "./GoalConfigModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports